import React from "react";
import styles from "./styles.module.scss";
import {t} from "i18next";
import {BodyTitleText} from "@/app/components/texts";
import {Assets} from "@/app/utils/assets";
import Image from "@/app/components/image";

interface CheckboxProps<T> {
  items: T[];
  onChange: (selected: T) => void;
  useS: boolean;
}

const Checkbox = <T, >({items, onChange, useS = false}: CheckboxProps<T>) => {

  return (
    <div className={styles.items}>
      {items.map((item, index) => (
        <label key={index} className={styles.items__item}>
          {useS ? (
            <BodyTitleText text={t(String(item))}/>
          ) : (
            <BodyTitleText text={String(item)}/>
          )}
          <input
            type="checkbox"
            onChange={() => onChange(item)}
            className={styles.items__input}
            id={`checkbox-${index}`}
          />
          <span className={styles.items__checkbox}>
            <Image asset={Assets.select} className={styles.items__checkmark}/>
          </span>
        </label>
      ))}
    </div>
  );
};

export default Checkbox;